import normalizeForSearch from "normalize-for-search"
import React, { ReactElement } from "react"
import { Link } from "react-router-dom"
import { Link as ExternalLink } from "@mui/material"

interface StylelessLinkProps {
  children: ReactElement | string | (ReactElement | string)[]
  to?: string
  external?: boolean
  onClick?: () => void
}
export const StylelessLink = ({ children, to, external = false, onClick }: StylelessLinkProps): React.ReactElement => {
  return to ? (
    external ? (
      <ExternalLink
        href={to}
        onClick={onClick}
        style={{ textDecoration: "inherit", color: "inherit", cursor: "pointer" }}
      >
        {children}
      </ExternalLink>
    ) : (
      <Link to={to} onClick={onClick} style={{ textDecoration: "inherit", color: "inherit", cursor: "pointer" }}>
        {children}
      </Link>
    )
  ) : (
    <div onClick={onClick}>{children}</div>
  )
}

export const FormatDate = (date: string, shortMonth: boolean = false, numberedMonth: boolean = false): string => {
  const year = date.slice(0, 4)
  const month = parseInt(date.slice(5, 7))
  const day = date.slice(8, 10)
  return numberedMonth
    ? `${day}/${month < 10 ? "0" + month : month}/${year}`
    : shortMonth
      ? `${parseInt(day)} ${shortMonths[month - 1]} ${year}`
      : `${parseInt(day)} ${months[month - 1]} ${year}`
}

export const formatSearch = (search: string): string => {
  return normalizeForSearch(search).replace(" ", "")
}

interface FormatParagraphsProps {
  content: string
}

export const FormatParagraphs = ({ content }: FormatParagraphsProps): React.ReactElement => {
  return (
    <>
      {" "}
      {content.split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </>
  )
}

const months = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
]
const shortMonths = ["Jan", "Fev", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Dec"]

export function delay(milliseconds: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, milliseconds))
}

export const CONSTANTS = {
  sideMenuWidth: 240,
  contact: {
    contact: { mail: "contact@hyris.tv" },
    presta: { mail: "hyris.prestations@centralesupelec.fr", name: "Sarah Gielen" },
    prez: { mail: "rayan-illyas.lahsini@student-cs.fr", name: "Ra-Yan Illyas Lahsini" },
    matos: { mail: "mathis.soubeyrand@student-cs.fr", name: "Mathis Soubeyrand" },
    rej: { mail: "mathis.duchatel@student-cs.fr", name: "Mathis Duchâtel" },
    geek: { mail: "geeks@hyris.tv" },
  },
  version: "1.7.3",
}
